import { render, staticRenderFns } from "./privacy-msg.vue?vue&type=template&id=a641c440&scoped=true&"
import script from "./privacy-msg.vue?vue&type=script&lang=js&"
export * from "./privacy-msg.vue?vue&type=script&lang=js&"
import style0 from "./privacy-msg.vue?vue&type=style&index=0&id=a641c440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a641c440",
  null
  
)

export default component.exports